<mat-tab-group>
  <mat-tab label="PESQUISAR" disabled>
    <h1>Selecione a empresa para importação em lote:</h1>
    <div class="search-box">
      <select [formControl]="searchType">
        <option value="1">BUSCA POR CNPJ</option>
        <option value="2">BUSCA POR RAZÃO SOCIAL</option>
      </select>
      <input
        #inputValue
        *ngIf="searchType.value == 1"
        [(ngModel)]="filterText"
        placeholder="01.234.567/0001-00"
        [textMask]="{
          mask: fiscalNumberMask,
          guide: false,
          keepCharPositions: true
        }"
        (keypress)="onPressEnterSearchCompanies($event)" />
      <input #inputValue *ngIf="searchType.value == 2" [(ngModel)]="filterText" placeholder="Razão Social" (keypress)="onPressEnterSearchCompanies($event)" />
      <div class="search-icon-container" (click)="searchCompanies(filterText)">
        <mat-icon aria-hidden="false">search</mat-icon>
      </div>
    </div>

    <div class="company-card" *ngIf="hasCompany()">
      <div class="company-logo">
        <img src="./assets/icons/no-logo-company-icon.svg" />
      </div>
      <div class="company-data">
        <div class="company-name">{{ company.getCorporateName() }}</div>
        <span class="company-cnpj"> CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }} </span>
        <span class="company-lives"> {{ company.getCompanyInfo().getEmployeeCount() }} vidas</span>
      </div>
    </div>
    <p class="txt" *ngIf="searchActionFired && searchNotFound">Nenhum resultado encontrado.</p>
    <hr *ngIf="searchActionFired" />

    <div class="on" *ngIf="hasCompany()">
      <mat-tab-group [(selectedIndex)]="tabIndex">
        <mat-tab label="PROCESSAR">
          <div class="file-header">
            <div class="export-container" (click)="openExportInfoModal()">
              <p class="txt" id="txt-height">Adicionar vários beneficiários de uma vez. <img src="./assets/icons/purple-info-icon.svg" /></p>
            </div>
            <a [href]="fileLink" download>
              <mat-icon aria-hidden="false" class="download-icon">file_download</mat-icon>
              <p class="txt">Faça download do arquivo modelo .csv</p>
            </a>
          </div>

          <div class="file-input">
            <form>
              <label for="file" *ngIf="!fileName">Clique aqui para selecionar o arquivo .CSV</label>
              <label for="file" *ngIf="fileName">{{ fileName }}</label>
              <input type="file" accept=".csv" id="file" files (change)="getFile($event)" />
              <button class="btn" (click)="uploadImportBeneficiaiesFile()">
                <mat-icon aria-hidden="false">add_box</mat-icon>
                ADICIONAR BENEFICIÁRIOS EM LOTE
              </button>
            </form>
          </div>
        </mat-tab>
        <mat-tab *ngIf="hasLastImportStatus()" label="RESULTADO">
          <div class="result-container">
            <h1>{{ lastImportStatus.statusLabel() }}</h1>
            <button
              [ngClass]="!lastImportStatus.isFinished() ? 'disabled-button' : 'download-button'"
              mat-flat-button=""
              color="accent"
              (click)="downloadFile()"
              [disabled]="!lastImportStatus.isFinished()">
              <mat-icon>download</mat-icon>
              BAIXAR RESULTADO
            </button>
            <p id="status" class="status-result" *ngIf="lastImportStatus.isFinished()">
              <mat-icon aria-hidden="false">{{ lastImportStatus.isFinished() ? "check" : "hourglass_full" }}</mat-icon>
              <span>
                {{ lastImportStatus.getStatusDescription() }}
              </span>
            </p>
            <div class="counters" *ngIf="lastImportStatus.isFinished()">
              <span>Atualizados: {{ lastImportStatus.info.totalUpdated }}</span>
              <span>Inseridos: {{ lastImportStatus.info.totalCreated }}</span>
              <span [ngClass]="lastImportStatus.info.totalFailed > 0 ? 'error-highlight' : ''">Itens com Erros: {{ lastImportStatus.info.totalFailed }}</span>
              <div *ngIf="lastImportStatus.info.totalFailed > 0" class="error-warning">
                <mat-icon aria-hidden="false">warning</mat-icon>
                <span>Baixe o arquivo de resultado para ver os detalhes dos erros</span>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <diV *ngIf="!hasCompany()" class="company-card-container">
      <div class="search-control">
        <p *ngIf="companyPageableResult.getItems().length > 1">{{ companyPageableResult.getItems().length }} RESULTADOS ENCONTRADOS</p>
        <p *ngIf="companyPageableResult.getItems().length === 1">1 RESULTADO ENCONTRADO</p>
        <div class="scroll-text" *ngIf="showScrollBottomBtn()" (click)="scrollToLastCompany()">
          <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
          <span class="btn-title">ir para o fim da lista</span>
        </div>
      </div>

      <div *ngFor="let company of getCompanies()">
        <div class="company-card">
          <div class="company-logo">
            <img src="./assets/icons/no-logo-company-icon.svg" />
          </div>
          <div class="company-data">
            <p class="company-name">{{ company.getCorporateName() }}</p>
            <p class="company-cnpj">CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }}</p>
            <p class="company-description">{{ company.getTradingName() }}</p>
          </div>
          <div class="company-status">
            <div class="status">
              <mat-icon aria-hidden="false">check_circle_outline</mat-icon>
              ATIVA
            </div>
            <div class="edit-btn" (click)="searchCompany(company)">
              <mat-icon aria-hidden="false">add_box</mat-icon>
              ADICIONAR
            </div>
          </div>
        </div>
      </div>

      <a class="more-companies-btn" *ngIf="showMoreCompaniesBtn()" (click)="searchMoreCompanies()">Carregar mais registros</a>
      <div id="bottom"></div>
    </diV>
  </mat-tab>
</mat-tab-group>
